export const getHighlightedStopSelector = (store: any): any =>
  store.machines.highlightedStop;

export const getMachinesSelector = (store: any): any => store.machines.machines;
